export const visit = (vm, at) => {
at({ "de": { "purchaseMotions": { "pricingPageRedirect": { "button": { "defaultButtonCopy": "Preise anzeigen" } } } } });
};